import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchFeaturedResources } from '../../../staticSiteBackend/resources';
export var createFeaturedResourcesQuery = function createFeaturedResourcesQuery(client, _ref) {
  var max = _ref.max;
  return [["resources", "featuredResourcesQuery", max], function (_ref2) {
    var signal = _ref2.signal;
    return fetchFeaturedResources({
      client: client,
      max: max,
      options: {
        signal: signal
      }
    });
  }];
};
export var useFeaturedResourcesQuery = createQueryHook(createFeaturedResourcesQuery, useStaticSiteBackend);